import HomeTraceabilites from "./traceabilityHome";
export default HomeTraceabilites;
